import { useTranslation } from "react-i18next";
import { CONTACT, PRODUCT, PROSPECT, QUOTE, TASK } from "v4/data/entities";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import { ids } from "v4/utils";

export default function useSearchLinkedEntitiesList(entity, checkedRows) {
    const { t } = useTranslation();
    const { getFlattenedNavigation } = useNavigation();
    const { flatMainNavigation } = getFlattenedNavigation();

    const isDisabled = checkedRows?.length === 0;

    const getSearchData = (searchedEntity, isReverse = false) => {
        // Get all routes with searchedEntity as search_type in mainNavigation
        const allRoutesWithSearchedEntity = flatMainNavigation.filter(route => route.search_type === searchedEntity);

        if (allRoutesWithSearchedEntity.length === 0) return null;

        return allRoutesWithSearchedEntity.map(route => ({
            key: `${route.slug}${isReverse ? '_reverse' : ''}`,
            link: {
                pathname: route.url,
                state: { [ids(entity)]: checkedRows, ...(isReverse && {isReverse: true})}
            },
            searchText: `${t(isReverse ? 'reverse_search_selection_in' : 'search_selection_in')} ${route.label}`,
        }));
    }

    const config = searchableEntitiesByEntity[entity] || { entities: [], inversableEntities: [] };
    const allEntities = [...new Set([...config.entities, ...config.inversableEntities])];

    const searchableList = allEntities.flatMap(e => [
        ...(config.entities.includes(e) ? (getSearchData(e) || []) : []),
        ...(config.inversableEntities.includes(e) ? (getSearchData(e, true) || []) : [])
    ]);


    return {
        isDisabled,
        searchableList,
    }
}

const searchableEntitiesByEntity = {
    [PROSPECT]: {
        entities: [CONTACT, TASK, QUOTE],
        inversableEntities: [],
    },
    [CONTACT]: {
        entities: [TASK, QUOTE],
        inversableEntities: [],
    },
    [TASK]: {
        entities: [CONTACT, PROSPECT],
        inversableEntities: [CONTACT, PROSPECT],
    },
    [QUOTE]: {
        entities: [CONTACT, PROSPECT],
        inversableEntities: [CONTACT, PROSPECT],
    },
    [PRODUCT]: {
        entities: [QUOTE],
        inversableEntities: [],
    }
}
